<template>
    <transition-group name="fade" tag="div" class="product-text" style="overflow: hidden;">
        <div class="product-banner">
            <div class="banner-item" style="margin-bottom: 40px;" v-for="(content, index) in topContent" :key="index" v-html="content.content"></div>
        </div>
        <div class="product-text__label" v-if="fixedList.length > 0">
            <span>{{fixedList.length}}&nbsp;&nbsp;大核心技术</span></div>
        <div class="product-text__item">
            <div class="item" v-for="(item, index) in fixedList" @click="handleClick(item)" :key="index">
                <el-image :src="item.imagePath"></el-image>
                <span class="item-text">了解详情 ></span>
            </div>
        </div>
    </transition-group>
</template>

<script>
    import minix from "@/mixin"
    import router from "@/route";
    import {gsap} from "gsap";
    export default {
        name: "coreVue",
        data() {
            return {
                topContent: [],
                fixedList: []
            }
        },
        mixins: [minix],
        methods: {
            handleClick(item) {
                router.push({
                    path: `/cvi/home/article/view`,
                    query: {
                        newId: item.id,
                        parentId: new URL(location.href).searchParams.get('parentId'),
                        activeIndex: new URL(location.href).searchParams.get('activeIndex'),
                        activeTag: new URL(location.href).searchParams.get('activeTag'),
                    }
                })
            }
        },
        created() {
            this.getBanner("core");
        },
        mounted() {
            this.$nextTick(()=> {
                gsap.set(".product-banner", {
                    opacity: 0
                })
                gsap.to(".product-banner",{
                    opacity: 1,
                    duration: 1.5
                })
            })
        }
    }
</script>

<style scoped lang="less">
    .product-banner {
        ::v-deep img {
            width: 100% !important;
        }
    }
    .product-text__view {
        margin-top: 60px;
    }
    .product-text__label {
        max-width: 1200px;
        margin: 40px auto;
        span{
            font-size: 34px;
            color: #184079;
            font-weight: bold;
            display: inline-block;
            line-height: 1;
            padding-bottom: 8px;
            width: max-content;
            border-bottom: 2px solid #FF6900;
        }
    }
    .product-text__item {
        max-width: 1200px;
        margin: 0 auto 60px;
        display: flex;
        justify-content: center;
        .item {
            cursor: pointer;
            flex: 1;
            margin-left: 20px;
            aspect-ratio: 225 / 180;
            border: 1px solid #ff6600;
            .el-image {
                width: 100%;
                height: calc(100% - 60px);
                color: #FF6900;
                overflow: visible !important;
            }
            .item-text {
                display: flex;
                width: 100%;
                border-top: 1px solid #ff6600;
                color: #ff6600;
                line-height: 60px;
                font-size: 20px;
                justify-content: center;
                align-items: center;
            }
            &:nth-of-type(1) {
                margin-left: 0;
            }
        }
    }
</style>
